import type { SearchParams } from '@/server/searchParams.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import { getAdultsChildrenInfantsCount, hasChildren } from '@/utils/peopleUtils.ts';

// 1 pax is out of both price displays; families get the single total, everyone else the toggler.
export type PriceDisplaySegment = 'single' | 'family' | 'multiPax';

export const getPriceDisplaySegment = (searchParams: SearchParams): PriceDisplaySegment => {
  if (getAdultsChildrenInfantsCount(searchParams) === 1) return 'single';

  return hasChildren(searchParams[URLParameters.AGES]) ? 'family' : 'multiPax';
};
